const {
  iterableCurry
} = require('../../internal/iterable.js');

function __some(iterable, func) {
  let c = 0;

  for (const value of iterable) {
    if (func(value, c++)) {
      return true;
    }
  }

  return false;
}

exports.__some = __some;
const some = /*#__PURE__*/iterableCurry(__some, {
  reduces: true
});
exports.some = some;